import type { EvidiaModalProps } from '@evidia/components';
import { EvidiaModal } from '@evidia/components';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { StepperType } from './Stepper';
import { Stepper } from './Stepper';
import { UpgradeMessage } from './UpgradeMessage';
import { FooterButton } from './styles';

type Props = EvidiaModalProps & {
	message?: string;
	linkTarget?: string;
	stepper?: StepperType;
};

export const UpgradeAccountModal = ({ linkTarget, message, stepper, okText, onOk, ...props }: Props) => {
	const navigate = useNavigate();

	const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		if (linkTarget) {
			navigate(linkTarget);
		}
		onOk?.(e);
	};

	const getModalFooter = () => (
		<FooterButton onClick={handleOnClick} type="primary">
			{okText}
		</FooterButton>
	);

	return (
		<EvidiaModal {...props} footer={getModalFooter()}>
			{message && <UpgradeMessage message={message} />}
			{stepper && <Stepper {...stepper} />}
		</EvidiaModal>
	);
};
